<template lang="pug">
    .contentpage
        .section(v-if="filteredSections.length" v-for="(section, index) in filteredSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Video(v-if="section.key === 'video'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
            Jumbotron(v-if="section.key === 'jumbotron'" :section="section")
            PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
            Downloads(v-if="section.key === 'downloads'" :section="section")
            Map(v-if="section.key === 'map'" :section="section")
            MapBox(v-if="section.key === 'mapbox'" :section="section")
            // CategoryPosts(v-if="section.key === 'categoryposts'" :max="4" :category="section.category")
            // Banners(v-if="section.key === 'banners'" :banners="section.contents")
            // SocialWall(v-if="section.key === 'socialwall'")
</template>

<script>

// import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Jumbotron from '@/components/Jumbotron'
import Post from '@/components/Post'
import Video from '@/components/Video'
import Slider from '@/components/Slider'
import PhotoAlbum from '@/components/PhotoAlbum'
import Downloads from '@/components/Downloads'
import Map from '@/components/Map'
import MapBox from '@/components/MapBox'
// import CategoryPosts from '@/components/CategoryPosts'
// import SocialWall from '@/components/SocialWall'
// import Banners from '@/components/Banners'

export default {
    name: 'ContentPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Video,
        Slider,
        PhotoAlbum,
        Jumbotron,
        Downloads,
        Map,
        MapBox,
        // CategoryPosts,
        // SocialWall,
        // Banners,
    },
    computed: {
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'video'
                    || section.key === 'slider'
                    || section.key === 'photoalbum'
                    || section.key === 'jumbotron'
                    || section.key === 'downloads'
                    || section.key === 'map'
                    || section.key === 'mapbox'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    },
    methods: {
        ...mapMutations({
            updateHeaderVisibility: 'updateHeaderVisibility',
        })
    },
    mounted() {
        this.updateHeaderVisibility(false)
    }
}

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';

    .jumbotron
        margin-top: 50px
        background-color: $darkgray
        &:last-of-type
            margin-bottom: -50px


    .contentpage
        & > .section
            padding-bottom: 0
            &:first-child
                padding-top: 4.5rem
            &:last-child
                padding-bottom: 4.5rem
            &.category-page-teaser
                display: none
        .section.slider,
        .section.banners
            padding: 0
        .section.heading
            text-transform: initial
</style>
